import type { Validate } from 'react-hook-form'
import { add, isAfter, isBefore } from 'date-fns'
import { isBeforeToday } from '@/components/ui/fields/DatePicker/helpers'
import type { TCheckingDateHelper } from '@/components/ui/ReactHookFormFields/DatePicker/helpers'
import type { TAdvancePaymentCalculatorForm } from '@/pages/AdvancePaymentOnFutureHarvest/components/AdvancePaymentCalculator/types'
import { isNonNullable } from '@/typeguards/common'
import {
  ADVANCE_PAYMENT_CALCULATOR_MAX_ADVANCE_PAYMENT_PERIOD_IN_MONTHS,
  ADVANCE_PAYMENT_CALCULATOR_MIN_LOAN_PERIOD_IN_DAYS,
} from './constants'
import { messages } from './messages'

export const isOutOfValidAdvancePaymentDateRange: TCheckingDateHelper = date =>
  !isNonNullable(date) ||
  isBeforeToday(date) ||
  isAfter(date, add(new Date(), { months: ADVANCE_PAYMENT_CALCULATOR_MAX_ADVANCE_PAYMENT_PERIOD_IN_MONTHS }))

export const isOutOfValidProductDeliveryDateRange =
  (advancePaymentDate: Maybe<Date>): TCheckingDateHelper =>
  productDeliveryDate =>
    !isNonNullable(advancePaymentDate) ||
    !isNonNullable(productDeliveryDate) ||
    isBefore(productDeliveryDate, add(advancePaymentDate, { days: ADVANCE_PAYMENT_CALCULATOR_MIN_LOAN_PERIOD_IN_DAYS }))

export const outOfValidProductDeliveryDateRangeRule: Validate<unknown, TAdvancePaymentCalculatorForm> = (
  _value,
  { advancePaymentDate, productDeliveryDate },
) => {
  if (advancePaymentDate && productDeliveryDate && isOutOfValidProductDeliveryDateRange(advancePaymentDate)(productDeliveryDate)) {
    return messages.error.datesOutOfRange
  }

  return undefined
}
